import { HERO_BG } from "@/mocks/lawfirm";
import CertificateCard from "./CertificateCard";

export default function Hero() {
  return (
    <section className="relative flex min-h-[720px] md:min-h-[820px] items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full mx-auto max-w-6xl px-4 md:px-6 pt-14 pb-28 md:pt-24 md:pb-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          {/* 좌측: 대표변호사 사진 + 이름표 (위 여백, 하단 꽉 채움) */}
          <div className="relative hidden w-56 shrink-0 sm:w-72 lg:block lg:w-[340px]">
            <div className="relative overflow-hidden rounded-2xl border border-white/60 bg-white/10 backdrop-blur pt-3 sm:pt-4">
              <div className="relative aspect-[2/3] w-full">
                <img
                  src="/images/pro_cl.png"
                  alt="법무법인 평율 김평호 대표변호사 프로필"
                  title="법무법인 평율 김평호 대표변호사"
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
                {/* 이름표 가독성을 위한 하단 그라데이션 */}
                <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              </div>
              {/* 하단: 이름표 + 전문분야 등록증서 나란히 */}
              <div className="absolute inset-x-0 bottom-0 z-10 flex items-end justify-between gap-3 px-4 pb-4 sm:px-5 sm:pb-5">
                <div className="min-w-0 text-left">
                  <p className="text-xs font-medium leading-snug text-white/75 sm:text-sm">
                    법무법인 평율 대표
                  </p>
                  <span className="mt-2 block h-px w-16 bg-gradient-to-r from-white/60 to-transparent"></span>
                  <p className="mt-2 font-heading text-xl font-bold leading-snug text-accent-300 sm:text-2xl">
                    김평호 변호사
                  </p>
                </div>
                <CertificateCard />
              </div>
            </div>
          </div>

          {/* 우측: 텍스트 콘텐츠 */}
          <div className="flex-1 text-center lg:text-left lg:pl-8 xl:pl-12">
            <p className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-5 py-2 text-xs md:text-sm font-medium tracking-wide text-white backdrop-blur">
              <i className="ri-shield-star-line text-accent-300"></i>
              광주부장판사·검사출신변호사
            </p>

            <h1 className="mt-6 font-heading text-3xl md:text-5xl font-bold leading-tight text-white tracking-tight">
              <span className="lg:hidden">
                재판의 흐름을 아는
                <br />
                김평호 변호사
              </span>
              <span className="hidden lg:inline">재판의 흐름을 아는 변호사</span>
            </h1>

            <p className="mx-auto lg:mx-0 mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-white/85">
              부장판사·검사로 쌓은 풍부한 경륜, 이제는 의뢰인을 위한 강력한 변호로 이어갑니다.
              <br className="hidden md:block" />
              25년 광주지방법원 부장판사퇴직, 대한변호사협회 등록 형사법전문변호사.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-start justify-center lg:justify-start gap-3 md:gap-4">
              <a
                href="tel:062-227-9990"
                className="inline-flex h-[52px] w-full sm:w-[220px] items-center justify-center gap-2 whitespace-nowrap rounded-md border border-transparent bg-accent-500 px-5 text-sm font-semibold text-white hover:bg-accent-600 transition-colors"
              >
                <i className="ri-phone-line text-lg"></i>
                법률상담 대표 전화
              </a>
              <a
                href="tel:062-227-9960"
                className="hidden sm:inline-flex h-[52px] w-full sm:w-[220px] items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/60 bg-white/10 px-5 text-sm font-semibold text-white backdrop-blur hover:bg-white/20 transition-colors"
              >
                <i className="ri-seedling-line text-lg"></i>
                회생파산센터 전화
              </a>
            </div>

            <div className="mt-10 hidden lg:flex flex-wrap justify-center lg:justify-start items-center gap-x-6 gap-y-4">
              {[
                { icon: "ri-scales-3-line", title: "25년 판사 퇴직", sub: "광주지법 부장판사" },
                { icon: "ri-scales-2-line", title: "형사법전문변호사", sub: "대한변호사협회 등록" },
                { icon: "ri-flashlight-line", title: "원스톱 업무 처리", sub: "수사부터 재판까지" },
              ].map((s, idx) => (
                <div key={s.title} className="flex items-center gap-2.5">
                  {idx > 0 && (
                    <span className="hidden sm:block h-8 w-px bg-white/20"></span>
                  )}
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500/90">
                    <i className={`${s.icon} text-base text-white`}></i>
                  </span>
                  <span className="text-left whitespace-nowrap">
                    <span className="block text-sm font-semibold text-white leading-tight">
                      {s.title}
                    </span>
                    <span className="block text-[11px] text-white/70 leading-tight">{s.sub}</span>
                  </span>
                </div>
              ))}
            </div>

            {/* 블로그 바로가기: 하나의 캡슐(세그먼트)로 평율 + 회생파산센터 */}
            <div className="mt-6 lg:mt-10 flex justify-center lg:justify-start">
              <div className="flex w-full flex-col overflow-hidden rounded-2xl border border-white/25 bg-white/10 backdrop-blur divide-y divide-white/15 sm:w-auto sm:flex-row sm:rounded-full sm:divide-x sm:divide-y-0">
                <a
                  href="https://blog.naver.com/py9990"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="group inline-flex h-[52px] w-full items-center justify-center gap-2.5 whitespace-nowrap px-6 text-sm font-semibold text-white transition-colors hover:bg-white/15 sm:w-auto"
                >
                  <i className="ri-scales-3-line text-base text-accent-300"></i>
                  법무법인 평율 블로그
                  <i className="ri-arrow-right-line text-base text-white/50 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-white"></i>
                </a>
                <a
                  href="https://blog.naver.com/lawpy9990"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="group inline-flex h-[52px] w-full items-center justify-center gap-2.5 whitespace-nowrap px-6 text-sm font-semibold text-white transition-colors hover:bg-white/15 sm:w-auto"
                >
                  <i className="ri-seedling-line text-base text-accent-300"></i>
                  회생파산센터 블로그
                  <i className="ri-arrow-right-line text-base text-white/50 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}